export const MAINTENANCE_TASK_MOBILE_PROPS = {
  HAS_MOBILE: 'hasMobile',
  NO_MOBILE: 'noMobile',
};
